import { createApi } from '@reduxjs/toolkit/query/react';

import { z3xBaseQuery } from 'app/utils/api.utils';
import { IPageableResponse } from 'app/types/pageable-response';
import { HydraApiResponse } from 'app/types/hydraData';
import { ITokenEvent } from 'app/types/token-event.interface';

interface ITokenEventGet {
  'userCrdAuthToken.userCrd': number,
  type?: number;
  page?: number
  itemsPerPage?: number
}

export const tokenEventApi = createApi({
  reducerPath: 'tokenEvents',
  baseQuery: z3xBaseQuery({ type: 'ld+json' }),
  endpoints: (builder) => ({
    getTokenEvents: builder.query<IPageableResponse<ITokenEvent>, ITokenEventGet>({
      query: ( params ) => ({
        url: 'token-events',
        params,
      }),
      transformResponse: (response: HydraApiResponse<ITokenEvent[]>) => {
        return {
          items: response['hydra:member'],
          totalItems: response['hydra:totalItems']
        };
      }
    }),
  }),
});

export const {
  useGetTokenEventsQuery,
  util: { resetApiState: tokenEventsResetApiState },
} = tokenEventApi;
